import {
    FETCH_MODELS_FAILURE,
    FETCH_MODELS_REQUEST,
    FETCH_MODELS_SUCCESS
} from '../actions/modelAction'

const initialState = {
    models: [],
    loading: false,
    error: null,
};

const modelReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MODELS_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_MODELS_SUCCESS:
            console.log("payload", action.payload)
            return { ...state, loading: false, models: action.payload };
        case FETCH_MODELS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default modelReducer;
